import {Button, Modal} from "react-bootstrap";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {getUpdatableFields, User} from "../../../../services/UsersService";
import {SliceStatus} from "../../../BaseState";
import {update as updateUser, userState} from "../UserSlice";
import {setIsOpened, userUpdateModalState} from "./UserUpdateModalSlice";
import ReactDiffViewer, {DiffMethod} from "react-diff-viewer";

interface UserUpdateModalProps {
  readonly user: User;
  readonly originalUser: User;
}

const UserUpdateModal = (props: UserUpdateModalProps) => {
  const state = useAppSelector(userUpdateModalState);
  const uState = useAppSelector(userState);
  const dispatch = useAppDispatch();

  const {user, originalUser} = props;
  const {isOpened, status} = state;

  const loading = status === SliceStatus.loading || uState.status === SliceStatus.loading;
  let error = state.error || uState.error;

  const handleClose = () => {
    dispatch(setIsOpened(false));
  };

  const handleUserUpdate = async () => {
    const result = await dispatch(updateUser({user, originalUser}));

    // error handling... This is so sad...
    if (!updateUser.rejected.match(result)) {
      dispatch(setIsOpened(false));
    }
  };

  return (
    <Modal show={isOpened} onHide={handleClose} fullscreen={true} dialogClassName="min-vw-100">
      <Modal.Header closeButton>
        <Modal.Title>Diff</Modal.Title>
      </Modal.Header>
      <Modal.Body className={"min-vw-100"}>
        <div className="container">
          {loading && <div className="row align-items-center">Updating</div>}
          {!loading && (
            <ReactDiffViewer
              oldValue={JSON.stringify(getUpdatableFields(originalUser), null, "\t")}
              newValue={JSON.stringify(getUpdatableFields(user), null, "\t")}
              compareMethod={DiffMethod.WORDS}
              hideLineNumbers={true}
              styles={{
                line: {
                  whiteSpace: "normal"
                }
              }}
              splitView
              leftTitle="original"
              rightTitle="changes"
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button className={`btn ${error ? "btn-danger" : "btn-primary"}`} onClick={handleUserUpdate} disabled={loading}>
          {error ? "Error Try Again" : "Update"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserUpdateModal;
